export default __webpack_public_path__ + "static/media/pattern6.109631f4.png";